import React, { useState, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import { createTheme } from "@material-ui/core/styles";
import { IconContext } from "react-icons/lib";
import { useHistory, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemButton from "@mui/material/ListItemButton";
import Collapse from "@mui/material/Collapse";
import { ReactComponent as ExpandLess } from "../assets/sidebaricons/downArrow.svg";
import { ReactComponent as ExpandMore } from "../assets/nextIcon.svg";
import UserService from "../services/user-service";
import AuthService from "../services/auth";
import logo from "../assets/logo.png";
import lightLogo from "../assets/largelogoLight.png";
import { withStyles } from "@material-ui/core/styles";
import MaterialTooltip from "@material-ui/core/Tooltip";
import cs from "classnames";

import { Container, Row, Col, Popover, OverlayTrigger } from "react-bootstrap";
import Button from "@mui/material/Button";
import { CopyToClipboard } from "react-copy-to-clipboard";

import { ReactComponent as HomePic } from "../assets/sidebaricons/blackhome.svg";
import { ReactComponent as BugPic } from "../assets/sidebaricons/bugIcon.svg";
import { ReactComponent as LogoutPic } from "../assets/sidebaricons/logoutgray.svg";
import { ReactComponent as SettingLogo } from "../assets/sidebaricons/settinglogo.svg";
import { ReactComponent as CopyPic } from "../assets/sidebaricons/copy.svg";
import shareLogo from "../assets/sidebaricons/share.svg";
import replayLogo from "../assets/repeat_icon.svg";
import "../styling/table.css";
import { useSelector, useDispatch } from "react-redux";
import { themModeSelector } from "../redux/selectors/AuthSelectors";
import { setUserInfo } from "../redux/actions/AuthAction";
import { sideBarList } from "../redux/actions/OnboardingAction";
import useWindowSize from "../hooks/useWindowSize";
import CustomModal from "./UI/CustomModal";
import MobileSidebarModal from "./MobileSidebarModal";
import { showMobileModalSelector } from "../redux/selectors/CalculatorSelectors";
import { showMobileHeaderModal } from "../redux/actions/CalculatorAction";
import Popup from "reactjs-popup";
import SuggestionPop from "../views/SuggestionPop";
import { ReactComponent as NextArrow } from "../assets/nextArrow.svg";

const theme = createTheme({
  overrides: {
    MuiListItem: {
      root: {
        width: "unset",
      },
    },
  },
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      textAlign: "center",
      position: "relative",
    },
    drawer: {
      textAlign: "center",
    },
    drawerPaper: {
      backgroundColor: "white",
      width: "16.67%",
      textAlign: "center",
    },
    logoBox: {
      display: "flex",
      justifyContent: "center",
    },
    leftspace: {
      padding: "20px 0 !important",
    },
    arrowleft: {
      cursor: "pointer",
      paddingTop: 15,
      paddingLeft: 35,
      "@media(max-width: 1025px)": {
        width: "23.9vw",
      },
    },
    openSidebar: {
      left: "-100%",
    },
    closeSidebar: {
      left: "0",
    },
    homeIcon: {
      minWidth: 31,
      marginBottom: 6,
    },
    bugLogo: {
      maxWidth: 295,
      width: "100%",
      color: "#7B7B7B",
      "@media(max-width: 1025px)": {
        width: "24vw",
      },
    },
    refCode: {
      maxWidth: 295,
      width: "100%",
      color: "#000",
      "@media(max-width: 1025px)": {
        width: "24vw",
      },
    },
    refLink: {
      color: "white",
      textDecoration: "underline",
      fontWeight: "bold",
    },
    replaylogo: {
      height: "21px",
      width: "21px",
    },
    tutorial: {
      maxWidth: 295,
      width: "100%",
      color: "#000",
      "@media(max-width: 1025px)": {
        width: "24vw",
      },
    },
    bottomlogout: {
      maxWidth: 295,
      width: "100%",
      color: "#7B7B7B",
      "@media(max-width: 1025px)": {
        width: "24vw",
      },
    },
    logout: {
      paddingLeft: 38,
      paddingTop: 10,
    },
    darkModeIcon: {
      "& svg": {
        stroke: "#fff",
      },
    },
    bussinessName: {
      "& span": {
        fontWeight: "bold",
        textAlign: "left",
        marginLeft: "15px",
      },
    },
    incomeStreamMenus: {
      "& span": {
        color: "#6c757d !important",
      },
    },
    selectedIncomeStream: {
      backgroundColor: "#eaf9ea !important",
      textDecoration: "none !important",
      "& .MuiListItemText-root span": {
        color: "#47c378 !important",
        fontWeight: "bold",
      },
    },
    // necessary for content to be below app bar
  })
);

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "black",
    boxShadow: theme.shadows[12],
    fontSize: 16,
    width: 120,
    height: "auto",
    textAlign: "center",
    cursor: "pointer",
  },
  arrow: {
    color: "white",
  },
}))(MaterialTooltip);

interface PermanentDrawerLeftProps {
  sidebar?: boolean;
  setSidebar?: (any) => void;
  isTutorial?: boolean | undefined;
  setOption?: (any) => void;
  reloadTableDataAPI?: boolean;
  setReloadTableDataAPI?: (any) => void;
  reloadAPI?: boolean;
}
const PermanentDrawerLeft: React.FC<PermanentDrawerLeftProps> = ({
  sidebar = false,
  setSidebar,
  isTutorial = false,
  setOption = () => {},
  reloadTableDataAPI,
  setReloadTableDataAPI,
  reloadAPI,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [inames, setINames] = useState([]);
  const [currLoading, setCurrLoading] = useState(true);
  const [ismodelopen, setIsmodelopen] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);
  const [activeIncomeStreamLog, setActiveIncomeStreamLog] = useState(0);
  const location = useLocation();
  const history = useHistory();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const { isDarkMode } = useSelector(themModeSelector);
  const [openIcomeStreamMenu, setOpenIncomeStreamMenu] = useState(0);
  const [reloadOption, setReloadOption] = useState(
    String(sessionStorage.getItem("option"))
  );
  const showMobileModalVal = useSelector(showMobileModalSelector);
  const { width } = useWindowSize();
  const [isOpen, setIsOpen] = useState(true);
  const [popCode, setPopCode] = useState(false);
  const [refCode, setRefCode] = useState("");
  const [urlCode, setUrlCode] = useState("");
  const [totRef, setTotRef] = useState(0);
  const [showMobileModal, setShowMobileModal] = useState(false);
  console.log("showMobileModalVal", showMobileModalVal);
  useEffect(() => {
    if (showMobileModalVal) {
      setShowMobileModal(true);
      dispatch(showMobileHeaderModal(false));
    }
  }, [showMobileModalVal]);

  const getReferral = () => {
    UserService.getReferral().then((response) => {
      if (response.data.code == "bad code") {
        alert("Some technical issues try again later");
      } else {
        if (response.data.total) {
          setTotRef(response.data.total);
        }
        setRefCode(response.data.code);
        const url =
          "https://www.sotira.app/auth/register?ref=" + response.data.code;
        setUrlCode(url);
        console.log(popCode);
        console.log("code rec.");
        setPopCode(true);
        console.log(popCode);
      }
    });
    //console.log('test109');
  };

  const hidePop = () => setPopCode(false);
  const handleCopy = () => {
    setPopCode(false);
  };

  const refCodePop = (
    <Popover
      style={{ marginLeft: 20 }}
      id="popover-basic"
      className="all-popover"
    >
      <Popover.Title as="h3" className="popover-title"></Popover.Title>
      <Popover.Content className="popover-content">
        Referral Link:{" "}
        <a className={classes.refLink}>
          {" "}
          https://www.sotira.app/auth/register?ref={refCode}{" "}
        </a>
        {totRef > 0 && <div>Total Number of Referrals: {totRef}</div>}
      </Popover.Content>

      <Button onClick={hidePop} className="popover-button">
        {" "}
        Done{" "}
      </Button>
      <CopyToClipboard text={urlCode}>
        <Button className="popover-button-copy">
          {" "}
          <CopyPic /> <span style={{ marginLeft: 10 }}> Copy Link </span>{" "}
        </Button>
      </CopyToClipboard>
    </Popover>
  );

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  var bussinessName = String(sessionStorage.getItem("bussinessStream"));

  const handleLogout = () => {
    AuthService.logout();
    history.push("/auth/login");
  };

  const handelesuggest =()=>{
    setIsmodelopen(true)
  };
  const handleLogo = () => {
    history.push("/");
  };

  useEffect(() => {
    setReloadOption(String(sessionStorage.getItem("option")));
    setOption(sessionStorage.getItem("option"));
  }, [reloadAPI, sessionStorage.getItem("option")]);

  useEffect(() => {
    incomeStreamDropDown();
  }, [reloadOption]);

  useEffect(() => {
    UserService.getIncome().then((response) => {
      setINames(response.data.iname);
      setCurrLoading(false);
    });
    UserService.getUserName().then((response) => {
      setFirstName(response.data.firstName);
      setLastName(
        response.data.lastName !== null ? response.data.lastName : ""
      );
      dispatch(setUserInfo(response.data));
    });
  }, [reloadTableDataAPI]);

  useEffect(() => {
    dispatch(sideBarList(inames));
  }, [inames]);

  const incomeStreamDropDown = () => {
    bussinessName === "" &&
      sessionStorage.setItem("bussinessStream", inames[0]);
    const activeStreamIndex = reloadOption;
    inames.map((incomeStream: any, index) => {
      var pageUrl = location.pathname;
      if (pageUrl.includes(incomeStream)) {
        setOpenIncomeStreamMenu(index);
        setActive(index);
        switch (activeStreamIndex) {
          case "sales":
            setActiveIncomeStreamLog(1);
            break;
          case "saved":
            setActiveIncomeStreamLog(2);
            break;
          default:
            setActiveIncomeStreamLog(0);
        }
      }
    });
  };

  const incomeStreamMenu = [
    { name: "Expense Tracker", option: "expense" },
    {
      name: "Sales Log",
      option: "sales",
    },
    {
      name: "Saved Pricing Calculations",
      option: "saved",
    },
  ];

  const handleIncomeStreamMenu = (option, bussinessStream) => {
    setOption(option);
    sessionStorage.setItem("option", option);
    sessionStorage.setItem("bussinessStream", bussinessStream);
  };

  return (
    <>
      <IconContext.Provider value={{ color: "black" }}>
        <nav className="overview-navbar">
          <div className="overview-icon">
            {!isTutorial && (
              <div style={{ marginLeft: 5 }}>
                <FaIcons.FaBars
                  id="menuIcon"
                  onClick={() => {
                    if (width > 600) {
                      setSidebar && setSidebar(!sidebar);
                      incomeStreamDropDown();
                    } else {
                      setShowMobileModal(!showMobileModal);
                    }
                  }}
                  className="sidebar-menu-icon"
                  style={{
                    color: isDarkMode ? "#fff" : "#000",
                    cursor: "pointer",
                  }}
                />
              </div>
            )}
            {!sidebar && (
              <img
                alt="logo"
                className="logo pointer-cursor"
                src={isDarkMode ? lightLogo : logo}
                onClick={handleLogo}
              />
            )}
          </div>
          <div className="d-flex justify-align-content-center align-items-center desktop">
            <p className="user-information">
              {firstName} {lastName !== null ? lastName.charAt(0) : ""}
            </p>
            <SettingLogo
              className="setting-logo"
              onClick={() => {
                history.push("/settings");
              }}
            />
            <LightTooltip
              interactive
              arrow
              PopperProps={{
                modifiers: {
                  offset: {
                    enabled: true,
                    offset: "1px 1px",
                  },
                },
              }}
              title={
                <div>
                  <div className="overview-setting">
                    <a href="/settings"> Settings </a>
                  </div>
                  <div className="overview-setting">
                    <a href="/etsy"> Synch Etsy Sales </a>
                  </div>
                  <div className="overview-setting">
                    <a href="/mint-NFTs"> NEAR Integration </a>
                  </div>
                  <div className="overview-logout" onClick={handleLogout}>
                    Logout
                  </div>
                </div>
              }
            >
              <div className="profile-icon">
                {firstName.charAt(0)}
                {lastName !== null ? lastName.charAt(0) : ""}
              </div>
            </LightTooltip>
          </div>
        </nav>
        <div
          className={
            sidebar
              ? `sidebar-navbar ${classes.closeSidebar}`
              : `sidebar-navbar ${classes.openSidebar}`
          }
        >
          <div className="sidebar-wrap">
            <div className="sidebar-logo">
              <div className="sidebar-icon">
                <FaIcons.FaBars
                  onClick={() => setSidebar && setSidebar(!sidebar)}
                  style={{
                    color: isDarkMode ? "#fff" : "#000",
                    cursor: "pointer",
                  }}
                />
              </div>
              <img
                alt="logo"
                className="logo"
                src={isDarkMode ? lightLogo : logo}
                onClick={handleLogo}
              />
            </div>
            <Divider />
            <ListItem
              className={cs(
                classes.arrowleft,
                "income-stream-bussinessname",
                { ["selected-menu"]: location.pathname === "/" },
                { ["selectedDark"]: isDarkMode }
              )}
              button
              component={Link}
              to="/"
              key="Home"
            >
              <ListItemIcon className={classes.homeIcon}>
                <HomePic className={isDarkMode && "dark-home-icon"} />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Box fontSize={25}>
                    <b>Home</b>
                  </Box>
                }
              />
            </ListItem>
            <Divider />
            <div className="d-flex justify-content-between flex-column sider-wrapper">
              <List className="top-sider-menu d-flex flex-column">
                {inames.map((incomeStream: any, index) => (
                  <>
                    <ListItemButton
                      className={` ${
                        active === index && "selected-menu"
                      } income-stream-bussinessname`}
                      key={incomeStream}
                      onClick={() => {
                        setActive(index);
                        setOpenIncomeStreamMenu(
                          openIcomeStreamMenu === index ? -1 : index
                        );
                        setOpen(!open);
                      }}
                    >
                      {inames.length > 1 ? (
                        openIcomeStreamMenu === index ? (
                          <ExpandLess className="expand-icon" />
                        ) : (
                          <ExpandMore className="expand-icon" />
                        )
                      ) : null}
                      <ListItemText
                        primary={incomeStream}
                        className={classes.bussinessName}
                      />
                    </ListItemButton>
                    <List>
                      <Collapse
                        in={openIcomeStreamMenu === index}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List className="d-flex flex-column income">
                          {incomeStreamMenu.map((text: any, i) => (
                            <ListItemButton
                              className={` ${
                                activeIncomeStreamLog === i &&
                                bussinessName === incomeStream &&
                                classes.selectedIncomeStream
                              }`}
                              component={Link}
                              to={{
                                pathname: "/stream/" + incomeStream,
                                state: { stream: index },
                              }}
                              onClick={() => {
                                setActive(index);
                                setActiveIncomeStreamLog(i);
                                handleIncomeStreamMenu(
                                  text.option,
                                  incomeStream
                                );
                              }}
                            >
                              <ListItemText
                                primary={text.name}
                                className={classes.incomeStreamMenus}
                              />
                            </ListItemButton>
                          ))}
                        </List>
                      </Collapse>
                    </List>
                  </>
                ))}
              </List>
              <div className="bottom-sider-menu" style={{marginBottom:"7px"}}>
                <List className={classes.refCode}>
                  <Divider />
                  <ListItem
                    className={classes.arrowleft}
                    button
                    onClick={getReferral}
                  >
                    <ListItemIcon>
                      <img src={shareLogo} className={classes.replaylogo} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Box>
                          <b>Share Sotira with a friend</b>
                        </Box>
                      }
                    />
                  </ListItem>
                  <OverlayTrigger
                    show={popCode}
                    placement="right"
                    overlay={refCodePop}
                  >
                    <p></p>
                  </OverlayTrigger>
                </List>
                <List
                  className={classes.tutorial}
                  onClick={() => {
                    history.push("/tutorial?replay=true");
                  }}
                >
                  <Divider />
                  <ListItem className={classes.arrowleft} button>
                    <ListItemIcon>
                      <img src={replayLogo} className={classes.replaylogo} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Box>
                          <b>Replay Tutorial</b>
                        </Box>
                      }
                    />
                  </ListItem>
                </List>
                <Divider />
                <List className={classes.bottomlogout} onClick={handelesuggest}>
                  <Divider />
                  <ListItem className={classes.logout} button>
                    <ListItemIcon>
                      <LogoutPic />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Box>
                          <b>Suggest a Feature</b>
                        </Box>
                      }
                    />              
                       <Popup
                          modal
                          nested
                          open={ismodelopen}

                          onClose={() => setIsmodelopen(false)}

                        >
                          {(close) => (
                            <div className="mode">
                              <button className="close" onClick={close}>
                                &times;
                              </button>
                              <div className="content">
                                <SuggestionPop closeModal={close} />
                              </div>
                            </div>
                          )}
                        </Popup>           
                        </ListItem>
                </List>
                 
                <Divider />
                <a href="https://forms.gle/C6Qf8aQQqSaD4wvd7">
                  <List className={classes.bugLogo}>
                    <Divider />
                    <ListItem className={classes.arrowleft} button>
                      <ListItemIcon>
                        <BugPic />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Box>
                            <b>Report Issues</b>
                          </Box>
                        }
                      />
                    </ListItem>
                  </List>
                </a>
                <Divider />
                <List className={classes.bottomlogout} onClick={handleLogout}>
                  <Divider />
                  <ListItem className={classes.logout} button>
                    <ListItemIcon>
                      <LogoutPic />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Box>
                          <b>Log Out</b>
                        </Box>
                      }
                    />
                  </ListItem>
                </List>
              </div>
            </div>
          </div>
        </div>
        <MobileSidebarModal
          showMobileModal={showMobileModal}
          setShowMobileModal={setShowMobileModal}
          sidebar={sidebar}
        />
      </IconContext.Provider>
    </>
  );
};

export default PermanentDrawerLeft;
